import { Form, Select, Button, DatePicker, Segmented } from "antd";
import find from "lodash/find";
import map from "lodash/map";
import get from "lodash/get";

import { getButtonDisabled } from "../../../utilities/helpers";

const HeaderSelector = ({
  filter,
  config,
  form,
  setFilters,
  getCompanyOperators,
  getDetails,
  setOperatorDetails
}) => {
  return (
    <div className="w-fit px-8 py-6">
      <div className="justify-end flex items-center h-full space-x-5 ">
        <Form.Item
          name="Company"
          label="Company"
          colon={false}
          layout="vertical"
        >
          <Select
            style={{ minWidth: 250 }}
            size="middle"
            optionFilterProp="label"
            showSearch
            value={get(filter, "company")}
            placeholder="Select Company"
            options={map(get(config, "companies"), (company) => ({
              label: get(company, "name"),
              value: get(company, "id"),
            }))}
            onChange={(val) => {
              const company = find(get(config, "companies"), ["id", val]);

              getCompanyOperators(company);
              form.setFieldsValue({
                template: undefined,
                operator: undefined,
              });
              setOperatorDetails(undefined)
            }}
          />
        </Form.Item>
        <Form.Item
          name="template"
          label="Template"
          colon={false}
          layout="vertical"
        >
          <Select
            style={{ minWidth: 250 }}
            size="middle"
            placeholder="Select Template"
            options={map(get(config, "templates"), (template) => ({
              label: get(template, "name"),
              value: get(template, "value"),
            }))}
            value={get(filter, "templateType")}
            onChange={(value) => {
              setFilters({
                ...filter,
                templateType: value,
              });
            }}
          />
        </Form.Item>
        <Form.Item
          name="operator"
          label="Operator"
          colon={false}
          layout="vertical"
        >
          <Select
            style={{ minWidth: 250 }}
            size="middle"
            placeholder="Select Operator"
            options={map(get(config, "operators"), (operator) => ({
              label: get(operator, "name"),
              value: get(operator, "id"),
            }))}
            value={get(filter, "operator.id")}
            onChange={(value) => {
              setFilters({
                ...filter,
                operator: find(get(config, "operators"), ["id", value]),
              });
            }}
          />
        </Form.Item>

        <Form.Item initialValue={get(filter, "date")} name="month" label="Month" colon={false} layout="vertical">
          <DatePicker
            format={"MM-YYYY"}
            onChange={(value, dateString) => {
              setFilters({
                ...filter,
                date: value,
              });
            }}
            value={get(filter, "date")}
            picker="month"
          />
        </Form.Item>

        <Form.Item name="submit" label=" " colon={false} layout="vertical">
          <Button
            type="primary"
            className="w-30"
            onClick={getDetails}
            disabled={getButtonDisabled(filter, [
              "templateType",
              "company",
              "date",
            ])}
          >
            Submit
          </Button>
        </Form.Item>
      </div>
    </div>
  );
};

export default HeaderSelector;
